import {opsApi} from 'services/apis'
import type {GetPricingResponse, GetPricingRequestBody} from 'types/orderTypes'

export const getPriceList = async (payload: GetPricingRequestBody) => {
  try {
    let url = 'products'
    const queryString = payload.products?.map(product => `products=${product}`).join('&')
    if (queryString) {
      url += `?${queryString}`
    }
    return await opsApi.get<GetPricingResponse>(url)
  } catch (e) {
    // TODO: toast
  }
}
